/* Testimonials — arrow navigation for the review carousel. */
(function () {
  'use strict';

  function initTestimonials(root) {
    var track = root.querySelector('[data-ts-track]');
    if (!track) return;
    root.querySelectorAll('[data-ts-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = track.querySelector('[data-ts-card]');
        var step = card ? card.offsetWidth + 16 : 320;
        var dir = btn.getAttribute('data-ts-nav') === 'next' ? 1 : -1;
        // Jump to an exact card position so scroll-snap agrees with the target
        var index = Math.round(track.scrollLeft / step) + dir;
        var max = Math.max(0, track.scrollWidth - track.clientWidth);
        var target = Math.min(max, Math.max(0, index * step));
        track.scrollTo({ left: target, behavior: 'smooth' });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-testimonials]').forEach(initTestimonials);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-testimonials]');
    if (root) initTestimonials(root);
  });
})();
